import { Outlet } from 'react-router-dom';

import { Tabs } from 'coreOld/components';
import { ITab } from 'coreOld/types';

interface IProps {
  tabItems: ITab[];
  onClick: (tab: ITab) => void;
}

const SystemSettingsView = ({ tabItems, onClick }: IProps) => {
  return (
    <Tabs tabs={tabItems} onClick={onClick}>
      <Outlet />
    </Tabs>
  );
};

export default SystemSettingsView;
